module.exports = __webpack_public_path__ + "img/Frame4301.5b262e06.jpg";